import { gql } from '@apollo/client'

export const CREATE_TAG = gql`
  mutation CreateTag($input: CreateTagInput!) {
    createTag(input: $input) {
      tag {
        id
        tag
        tagType
        startDate
        endDate
        description
        active
        include
        exclude
        createdAt
      }
    }
  }
`

export const UPDATE_TAG = gql`
  mutation UpdateTag($input: UpdateTagInput!) {
    updateTag(input: $input) {
      tag {
        id
        tag
        tagType
        description
        startDate
        endDate
        active
        include
        exclude
      }
    }
  }
`

export const DELETE_TAG = gql`
  mutation DeleteTag($input: DeleteTagInput!) {
    deleteTag(input: $input) {
      success
      deletedTagId
    }
  }
`

export const TEST_TAG_CRITERIA = gql`
  mutation TestTagCriteria($input: TestTagCriteriaInput!) {
    testTagCriteria(input: $input) {
      patientIds
      patientCount
    }
  }
`

export const EXECUTE_TAG_CRITERIA = gql`
  mutation ExecuteTagCriteria($input: ExecuteTagCriteriaInput!) {
    executeTagCriteria(input: $input) {
      patientIds
      patientCount
    }
  }
`

export const TAG_PATIENTS = gql`
  mutation TagPatients($input: TagPatientsInput!) {
    tagPatients(input: $input) {
      success
    }
  }
`

export const UNTAG_PATIENTS = gql`
  mutation RemoveTagFromPatients($input: RemoveTagFromPatientsInput!) {
    removeTagFromPatients(input: $input) {
      success
    }
  }
`
